import { getLeadCustomFieldsError } from './customFieldAnswers';

export const normalizeCrmImportKey = (value) =>
  String(value || "")
    .trim()
    .normalize('NFKC')
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]/gu, "");

export const buildCrmFileFields = (formSchema = [], t = (value) => value) => {
  const fixedFields = [
    { key: "Column", label: t("Column"), isCustom: false },
    { key: "Amount", label: t("Amount"), isCustom: false },
    { key: "Country", label: t("Country"), isCustom: false },
    { key: "Notes", label: t("Notes"), isCustom: false },
  ];

  return [...fixedFields, ...(Array.isArray(formSchema) ? formSchema : [])];
};

export function buildCrmImportFields(formSchema = [], headers = [], { standalone = false, t = value => value } = {}) {
  const fields = buildCrmFileFields(formSchema, t);
  if (!standalone) return fields;
  const used = new Set(fields.flatMap(field => [normalizeCrmImportKey(field.key), normalizeCrmImportKey(field.label)]));
  for (const header of headers) {
    const key = String(header || '').trim();
    const normalized = normalizeCrmImportKey(key);
    if (used.has(normalized) || getLeadCustomFieldsError([{ key }])) continue;
    used.add(normalized);fields.push({ key, label: key, isCustom: true });
  }
  return fields;
}

export const getTemplateHeader = (field) => field?.label || field?.key || "";

export const getTemplateSampleValue = (header, firstColumnTitle = "") => {
  const normalized = normalizeCrmImportKey(header);

  if (normalized === "column") return firstColumnTitle || "New Lead";
  if (normalized === "fullname") return "Maria Papadopoulou";
  if (normalized === "name" || normalized === "firstname") return "Maria";
  if (normalized === "surname" || normalized === "lastname") return "Papadopoulou";
  if (normalized === "email") return "maria@example.com";
  if (normalized === "tel" || normalized === "phone") return "+306912345678";
  if (normalized === "city") return "Athens";
  if (normalized === "country") return "+30";
  if (normalized === "amount") return "1500";
  if (normalized === "notes") {
    return "Called the client\nAsked for pricing\nWants a follow-up next week";
  }

  return "";
};

export const formatCrmNotesForFile = (notes = [], formatDate = (value) => value) => {
  if (!Array.isArray(notes) || !notes.length) return "";

  return notes
    .map((note) => {
      const text = note?.text?.trim?.() || "";
      if (!text) return "";

      const date = note?.createdAt ? formatDate(note.createdAt) : "";
      return date ? `${date}: ${text}` : text;
    })
    .filter(Boolean)
    .join("\n");
};

export const parseCrmNotesFromFile = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return [];

  return raw
    .split(/\r?\n+/)
    .map((line) => String(line || "").trim())
    .filter(Boolean)
    .map((line) => {
      const datedMatch = line.match(/^(\d{2})\/(\d{2})\/(\d{4}):\s*(.*)$/);

      if (datedMatch) {
        const [, day, month, year, rawText] = datedMatch;
        const createdAt = new Date(
          Number(year),
          Number(month) - 1,
          Number(day),
          12,
          0,
          0,
          0
        );

        return {
          text: (rawText || line).trim(),
          createdAt: createdAt.toISOString(),
        };
      }

      return { text: line };
    });
};
